import {useQuery} from '@tanstack/react-query'
import {api} from '@/lib/api'
import type {components} from '@/lib/api-schema'
import type {BateriaReporteAlcance} from '@/hooks/bateria/use-bateria'

// P7/G11: el mismo `ReporteData` que hornea el DOCX.
export type ReporteDatos = components['schemas']['ReporteDatosRead']
export type FormaResumen = components['schemas']['FormaResumenRead']
export type NivelResumen = components['schemas']['NivelResumenRead']
export type DemoCorte = components['schemas']['DemoCorteRead']
export type Profesional = components['schemas']['ProfesionalRead']
export type FactorPlan = components['schemas']['FactorPlanRead']
export type AccionesPlan = components['schemas']['AccionesPlanRead']
export type Periodicidad = components['schemas']['PeriodicidadRead']
export type ValidezDatos = components['schemas']['ValidezRead']

const base = (businessId: string) => `/admin/businesses/${businessId}/bateria`

/** El agregado se pide al servidor por `alcance`, nunca se filtra en el cliente. 409 `sin_validados` si no hay
 * paquetes validados en ese alcance. */
export function useReporteDatos(
  businessId: string | undefined,
  evaluacionId: string | undefined,
  alcance: BateriaReporteAlcance,
  enabled: boolean
) {
  return useQuery({
    queryKey: ['bateria-reporte-datos', businessId, evaluacionId, alcance],
    queryFn: async () =>
      (
        await api.get<ReporteDatos>(`${base(businessId!)}/evaluaciones/${evaluacionId}/reporte-datos`, {
          params: {alcance},
        })
      ).data,
    enabled: enabled && !!businessId && !!evaluacionId,
  })
}
